import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material/styles';
import merge from 'lodash-es/merge';

import { MountPointContext } from '@repo/common-utils/mountPoint';
import {
    customizationAtom,
    CustomizationsContext,
} from 'src/components/utils/theme/customizations';
import { MUITheme } from 'src/components/utils/theme/Theme';
import { ThemeType } from 'src/components/utils/theme/ThemeType';
import { StateProvider } from 'src/state/StateProvider';
import { useAtom } from 'ximple/atoms';
import { AuthenticationContextProvider } from './timeslots/timeslots/AuthenticationContext';
import { MemberContextProvider } from './timeslots/timeslots/MemberContext';
import { NativeMemberContextProvider } from './native-membership/NativeMemberContext';

import type { JSX } from 'react';

export function WidgetWrapper(props: {
    mountPoint: HTMLDivElement;
    popoverMountPoint: HTMLDivElement;
    shadowRoot: ShadowRoot;
    customizationOverrides?: Partial<{ [key in keyof ThemeType]: ThemeType[keyof ThemeType] }>;
    children: any;
}): JSX.Element {
    const [customizations] = useAtom(customizationAtom);
    const customizationsWithOverrides = merge(customizations, props.customizationOverrides);

    const cache = createCache({
        key: 'css',
        prepend: true,
        container: props.mountPoint,
    });

    return (
        <CacheProvider value={cache}>
            <ThemeProvider theme={MUITheme(customizationsWithOverrides)}>
                <CustomizationsContext.Provider value={customizationsWithOverrides}>
                    <MountPointContext.Provider
                        value={{
                            popover: props.popoverMountPoint,
                            shadowRoot: props.shadowRoot,
                        }}
                    >
                        <AuthenticationContextProvider>
                            <MemberContextProvider>
                                <NativeMemberContextProvider>
                                    <StateProvider>{props.children}</StateProvider>
                                </NativeMemberContextProvider>
                            </MemberContextProvider>
                        </AuthenticationContextProvider>
                    </MountPointContext.Provider>
                </CustomizationsContext.Provider>
            </ThemeProvider>
        </CacheProvider>
    );
}
